// Every deploy replaces the hashed chunks in /assets, so a tab opened before it
// asks for files that no longer exist; Firebase Hosting answers those with
// index.html and the browser refuses it as a module. Reloading fetches the new
// index.html and its new chunks.

const RELOADED_AT_KEY = "vntr18.stale-build-reloaded-at";
// A chunk still missing this soon after a reload is not a stale tab; reloading
// again would loop.
const RELOAD_COOLDOWN_MS = 30_000;
// Chrome, Firefox and Safari word the failed dynamic import differently; the
// last one is Vite failing to preload a chunk's CSS.
const CHUNK_LOAD_ERROR = /dynamically imported module|Importing a module script failed|Unable to preload CSS/i;

export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && CHUNK_LOAD_ERROR.test(error.message);
}

/** Reload to pick up the latest deploy. False when one was just tried. */
export function reloadForNewBuild(now: number = Date.now()): boolean {
  try {
    const lastReload = Number(window.sessionStorage.getItem(RELOADED_AT_KEY) ?? 0);
    if (now - lastReload < RELOAD_COOLDOWN_MS) return false;
    window.sessionStorage.setItem(RELOADED_AT_KEY, String(now));
  } catch {
    // No storage means no loop guard, so don't reload at all.
    return false;
  }
  window.location.reload();
  return true;
}
